import './TodoItem.css';

export function TodoItem({ onComplete, onDelete, todoText = 'Eat food.', completed = false }) {
  return (
    <li className={`TodoItem${completed ? ' checked' : ''}`}>
      <div>
        <span className={`TodoItem__Check${completed ? ' checked' : ''}`} onClick={onComplete}>&#10004;</span>
      </div>
      <p className={`TodoItem__Text${completed ? ' completed' : ''}`}>
        {todoText}
      </p>
      <span className='TodoItem__Delete' onClick={onDelete}>&times;</span>
    </li>
  )
}